import { useQuery } from 'react-query';
import { getMealOptions } from '../api/getMealOptions';

const useMealOptions = (benefitID) => {
  const data = useQuery(['mealOptions', benefitID], () => getMealOptions(benefitID), {
    enabled: !!benefitID, // Only run query if benefit_id is available
    refetchOnWindowFocus: true,
    staleTime: 50000,
  });
  //   console.log('here is the data from useMealOptions: ', data);
  return data;
};

export default useMealOptions;
